import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalButtons} from 'shared/components/modals';

const PublishedShiftChangeModal = observer(({uiState, isOpen}) => {
  const {action, shift} = uiState.publishedShiftChangeRequest;
  const deleting = action === 'delete';

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => uiState.closePublishedShiftChangeModal()}
      size='sm'
      title={deleting ? 'time_tracking.shifts.Delete Published Shift' : 'time_tracking.shifts.Edit Published Shift'}
    >
      <div className='jumbo mb2'>
        <FormattedMessage id='time_tracking.shifts.SHIFT_ALREADY_PUBLISHED'/>
      </div>
      {uiState.schedule.sendSchedulePublishedNotification && shift?.employee &&
        <div className='jumbo mb2'>
          <FormattedMessage
            id={deleting ? 'time_tracking.shifts.PUBLISHED_SHIFT_DELETED_EMAIL_NOTICE' : 'time_tracking.shifts.PUBLISHED_SHIFT_UPDATED_EMAIL_NOTICE'}
            values={{name: shift.employee.name}}
          />
        </div>
      }
      <ModalButtons
        saveCaption={deleting ? 'time_tracking.shifts.Delete' : 'time_tracking.shifts.Update'}
        trait={deleting ? 'destructive' : 'primary'}
        onSave={() => uiState.confirmPublishedShiftChange()}
        onCancel={() => uiState.closePublishedShiftChangeModal()}
      />
    </Modal>
  );
});

export default PublishedShiftChangeModal;
